import React from "react";

import Member from "./Member";

const Members = () => {
  return (
    <div class="mt-8">
      <h3 class="text-xl font-bold">Team Members</h3>
      <Member />
    </div>
  );
};

export default Members;
